const process = require('process');
const _ = require('lodash');
let env = {};

if (process.browser) {
  env = _.assign({}, env, window._env);
} else {
  env = _.assign({}, env, {
    nodeEnv:
      process.env && process.env.NODE_ENV ? process.env.NODE_ENV : 'production',
    serviceEnv:
      process.env && process.env.SVCENV ? process.env.SVCENV : 'staging',
    apiURL:
      process.env && process.env.API_URL
        ? process.env.API_URL
        : 'https://frontend-active.prod.thinkofliving.com/api/',
  });
}

class EnvHelper {
  static getEnv() {
    return env.nodeEnv;
  }

  static getServiceEnv() {
    return env.serviceEnv;
  }

  static getApiURL() {
    return env.apiURL;
  }
}

module.exports = EnvHelper;
